import { ReactNode } from 'react';

interface HotelBoxV2Props extends React.HTMLAttributes<HTMLDivElement> {
}

export default function HotelBoxV2({ children, className, ...props }: HotelBoxV2Props) {
    return (
        <div {...props} className={`${className} md:bg-white py-3 border-t md:border-t-0 md:rounded-3xl md:p-2 lg:p-4 w-full`}>
            {children}
        </div>
    );
}

interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
}

const Header = ({ children, className, ...props }: HeaderProps) => {
    return <h2  {...props} className={`${className} text-lg font-semibold text-gray-800  w-full`}>
        {children}
    </h2>
}

interface BodyProps extends React.HTMLAttributes<HTMLDivElement> {
}

const Body = ({ children, ...props }: BodyProps) => {
    return <div {...props} className={`${props.className} text-3 md:text-sm text-gray-800 mt-3 first:mt-0 w-full`}>
        {children}
    </div>
}

interface FooterProps extends React.HTMLAttributes<HTMLDivElement> {
}

const Footer = ({ children, ...props }: FooterProps) => {
    return <div {...props} className='text-xs text-indigo-500 w-full mt-3 py-[7px] lg:hidden'>
        {children}
    </div>
}

HotelBoxV2.Header = Header
HotelBoxV2.Body = Body
HotelBoxV2.Footer = Footer